import axios from "axios";

// Create axios instance
const service = axios.create({
  // baseURL: "http://127.0.0.1:8000/api/v1/",
  baseURL: "http://103.82.37.62/api/v1/",
  timeout: 60000, // Request timeout
});

export default service;
